
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/commanders",
      function () {
        return require("private-next-pages/commanders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/commanders"])
      });
    }
  